
import { Calendar } from "@/components/ui/calendar";
import { Label } from "@/components/ui/label";
import { addMonths, addWeeks } from "date-fns";
import { cn } from "@/lib/utils";

interface DateSectionProps {
  preferredDates: Date[];
  onDateSelect: (dates: Date[] | undefined) => void;
  error?: string;
}

export const DateSection = ({
  preferredDates,
  onDateSelect,
  error
}: DateSectionProps) => {
  // Create date constraints in local timezone
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const minDate = addWeeks(today, 1);
  const maxDate = addMonths(today, 6);
  
  return <div>
      <Label>Select potential dates</Label>
      <div className={cn("overflow-hidden", error && "border-destructive")}>
        <Calendar 
          mode="multiple" 
          selected={preferredDates} 
          onSelect={onDateSelect} 
          className="w-full" 
          fromDate={minDate} 
          toDate={maxDate} 
          disabled={date => date < minDate || date > maxDate} 
        />
        {error && <p className="text-sm text-destructive mt-1">{error}</p>}
      </div>
    </div>;
};
